import { useCallback } from 'react';
import apiServices from '../services/api/index';
import { ApiServicesWithHandleError } from '../types/api';

/**
 * API 서비스를 모두 가져와서 사용할 수 있게 해주는 훅
 * 컴포넌트에서 API 호출을 간편하게 할 수 있습니다.
 * 
 * @example
 * const { authApi } = useApiService();
 * // 로그인 시도
 * const handleLogin = async () => {
 *   const response = await authApi.login({ username, password });
 *   if (response.success) {
 *     // 로그인 성공 처리
 *   }
 * };
 */
export const useApiService = (): ApiServicesWithHandleError => {
  const handleApiError = useCallback((error: any) => {
    console.error('API Error:', error);
    if (error.response) {
      console.error('Error Response:', error.response.data);
    }
    throw error;
  }, []);

  return {
    ...apiServices,
    handleApiError
  } as unknown as ApiServicesWithHandleError;
};

export default useApiService; 